import React from 'react'
import { Form, useNavigate } from 'react-router-dom';
import Pricing from './Pricing';
import SafetyTraining from './SafetyTraining';
import ContactForm from './Form';




const HomePage = ()=> 
{
    const navigate = useNavigate();

   return (
    <div>
   <section className="section-background">
   
    <section className='left-body'>
    <section className='big-font'>
    <p id='top-gap'>Virtual Reality </p>
    <p id="bold"> Safety Training </p>
    </section>
    <p className='font-main' >VIRSAT is a company with expertise in HSE, Learning, IT and gaming solutions </p>
    <p className='font-main'>for businesses. VIRSAT has a track record of implementing safety solutions. </p>
    <p className='font-main'>We build and deliver novel tools to improve safety in the Inudstry.</p>

    <div className="button-container">

    <button className='body-button' onClick={()=>navigate('/life-saving')}>Learn More</button>
    <button className='body-button' onClick={()=>navigate('/pclicense')}>Get Access</button>
    </div>
    </section>

    </section>
    <SafetyTraining />
<><Pricing/> </>
<ContactForm/>
</div>
    );

};

export default HomePage;
